import React, { useState } from "react";
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { EXECUTIVE_PG_DEVOPS_PROGRAM } from "../../constants/AzureDevops";

export default function FAQSection(props) {
  const { isSmallScreen, city, course, executiveFaqs, defaultFaqs, cityFaqs } = props;
  const [expanded, setExpanded] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const handleChange = (panel) => (_, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const faqs =
    (city && cityFaqs && cityFaqs[city]) ||
    (course === EXECUTIVE_PG_DEVOPS_PROGRAM ? executiveFaqs : defaultFaqs);

  const visibleFaqs = showAll ? faqs : faqs.slice(0, 5);

  return (
    <Box sx={{ py: 10, px: { xs: 2, md: 8 }, width: isSmallScreen ? "90%" : "80%", mx: "auto" }}>
      <Typography
        variant={isSmallScreen ? "h5" :"h4"}
        sx={{ fontWeight: 700, color: "#6B21A8", mb: 1 }}
      >
        Frequently Asked Questions
      </Typography>
      <Typography variant="body1" sx={{ color: "#333", mb: 4, fontSize: isSmallScreen && "0.9rem" }}>
        Got Questions? We’ve Got You Covered. <br />
        From course details to career support, we’ve made it easy. Everything
        you need to know — clear, simple, and straight to the point.
      </Typography>

      {visibleFaqs.map((faq, index) => (
        <Accordion
          key={index}
          expanded={expanded === index}
          onChange={handleChange(index)}
          sx={{
            backgroundColor: "#fff",
            borderRadius: "5px !important",
            mb: 2,
            boxShadow: " 0px 1px 1px rgba(0,0,0,0.5)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "#6B21A8" }} />}
            sx={{
              "& .MuiAccordionSummary-content": {
                fontWeight: 600,
                color: "#333",
                fontSize: isSmallScreen && "0.9rem"
              },
            }}
          >
            {faq.question}
          </AccordionSummary>
          <AccordionDetails sx={{ color: "#555", fontSize: isSmallScreen? "0.8rem" : "0.95rem" }}>
            {faq.answer}
          </AccordionDetails>
        </Accordion>
      ))}

      <Box textAlign="center" mt={3}>
        <Button
          aria-label={showAll ? "Read Less FAQs" : "Read More FAQs"}
          onClick={() => setShowAll(!showAll)}
          variant="text"
          sx={{
            color: "#6B21A8",
            fontWeight: 600,
            textTransform: "none",
            fontSize: "1rem",
          }}
        >
          {showAll ? "Read Less ▲" : "Read More ▼"}
        </Button>
      </Box>
    </Box>
  );
}
